// eslint-disable-next-line
export function getQueryStringValue(key) {
// eslint-disable-next-line
  const regExp = `^(?:.*[&\\?]${encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&')}(?:\\=([^&]*))?)?.*$`;
  return decodeURIComponent(window.location.search.replace(new RegExp(regExp, 'i'), '$1'));
}
